import type { Imagem } from '@equiview/domain';
import { corNoPonto, pixelsDaFoto, processar, type ResultadoDaDeteccao } from './deteccao-nucleo.js';

export type { ResultadoDaDeteccao };

/** O arquivo da foto (blob local ou link assinado), lido uma vez por tela. */
let ultima: { url: string; blob: Promise<Blob> } | null = null;
const blobDaFoto = (url: string) => {
  if (ultima?.url !== url) {
    ultima = { url, blob: fetch(url).then((r) => (r.ok ? r.blob() : Promise.reject(new Error('Não foi possível abrir a foto.')))) };
  }
  return ultima.blob;
};

let pixels: { url: string; img: Promise<Imagem> } | null = null;

/** Acha e identifica os marcadores da cor informada. Num Web Worker quando o aparelho tem. */
export async function detectarNaFoto(url: string, cor: string, marcadores?: readonly string[]): Promise<ResultadoDaDeteccao> {
  const blob = await blobDaFoto(url);
  if (typeof Worker !== 'undefined' && typeof OffscreenCanvas !== 'undefined') {
    try {
      return await noWorker(blob, cor, marcadores);
    } catch {
      // Worker indisponivel (navegador antigo, bloqueio): segue na thread principal.
    }
  }
  return processar(await imagem(url, blob), cor, marcadores);
}

/** A cor do adesivo no ponto tocado da foto (0-1). */
export async function corNaFoto(url: string, x: number, y: number): Promise<string> {
  return corNoPonto(await imagem(url, await blobDaFoto(url)), x, y);
}

function imagem(url: string, blob: Blob): Promise<Imagem> {
  if (pixels?.url !== url) pixels = { url, img: pixelsDaFoto(blob) };
  return pixels.img;
}

function noWorker(blob: Blob, cor: string, marcadores?: readonly string[]): Promise<ResultadoDaDeteccao> {
  return new Promise((resolve, reject) => {
    const w = new Worker(new URL('./deteccao.worker.ts', import.meta.url), { type: 'module' });
    w.onmessage = (e: MessageEvent<{ ok: true; resultado: ResultadoDaDeteccao } | { ok: false; erro: string }>) => {
      w.terminate();
      if (e.data.ok) resolve(e.data.resultado);
      else reject(new Error(e.data.erro));
    };
    w.onerror = (e) => {
      w.terminate();
      reject(new Error(e.message));
    };
    w.postMessage({ blob, cor, marcadores: marcadores ? [...marcadores] : undefined });
  });
}
